// @flow
import { Grid } from 'semantic-ui-react';
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';

import { SelectField } from '../../../formik-utils/FormFields';
import { getDropdownOptions } from '../../stream-governance/utils';
import { EstimateCommittedCapacityMetadataContext } from '../../../contexts/EstimateCommittedCapacityMetadataContext';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import {
  getDimensionFieldPathForEstimateCC,
  getIfGivenRowIsANewlyAddedRowForEstimateCC,
} from '../utils';

export const ECKUDimensionColumnsForEstimateCC = ({ metricIndex, dimensionIndex, row }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const providerPath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME
  );
  const clusterTypePath = getDimensionFieldPathForEstimateCC(
    metricIndex,
    dimensionIndex,
    ESTIMATE_COMMITTED_CAPACITY.CLUSTER_TYPE_BACKEND_FIELD_NAME
  );

  const providerColConfig = {
    backendFieldName: ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME,
    displayNameCol: ESTIMATE_COMMITTED_CAPACITY.PROVIDER_LABEL_DISPLAY_NAME_COL,
    parentFieldsInGroup: [],
  };

  const clusterTypeColConfig = {
    backendFieldName: ESTIMATE_COMMITTED_CAPACITY.CLUSTER_TYPE_BACKEND_FIELD_NAME,
    displayNameCol: ESTIMATE_COMMITTED_CAPACITY.CLUSTER_TYPE_LABEL_DISPLAY_NAME_COL,
    parentFieldsInGroup: [ESTIMATE_COMMITTED_CAPACITY.PROVIDER_BACKEND_FIELD_NAME],
  };

  const dataUniverse =
    useContext(EstimateCommittedCapacityMetadataContext)?.committed_cku_capacity_configs ?? [];

  const providerDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    providerColConfig,
    false,
    false,
    false,
    true
  );

  const clusterTypeDropDownOptions = getDropdownOptions(
    dataUniverse,
    row,
    clusterTypeColConfig,
    false,
    false,
    false,
    true
  );

  const shouldColumnBeDisabled = !getIfGivenRowIsANewlyAddedRowForEstimateCC(row);

  return (
    <>
      <Grid.Column width={3}>
        <SelectField
          addLabel={false}
          disableOnFormErrors={false}
          disabled={shouldColumnBeDisabled}
          fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.PROVIDER_DISPLAY_NAME}
          fieldName={providerPath}
          onChange={async () => {
            await setFieldValue(clusterTypePath, null);
            await setFieldTouched(clusterTypePath, true);
          }}
          options={providerDropDownOptions}
        />
      </Grid.Column>
      <Grid.Column width={3}>
        <SelectField
          addLabel={false}
          disableOnFormErrors={false}
          disabled={shouldColumnBeDisabled}
          fieldDisplayName={ESTIMATE_COMMITTED_CAPACITY.CLUSTER_TYPE_DISPLAY_NAME}
          fieldName={clusterTypePath}
          options={clusterTypeDropDownOptions}
        />
      </Grid.Column>
    </>
  );
};
